<template>
  <div class="not-found">
    <div class="not-found-card">
      <img src="/assets/Logo.png" alt="Logo" class="not-found-logo" />
      <div class="not-found-code">404</div>
      <h1>Ruta no encontrada</h1>
      <p>La página que buscas no existe o fue movida.</p>
      <router-link to="/" class="btn btn-primary mb-0">Ir al inicio</router-link>
    </div>
  </div>
</template>

<script>
const body = document.getElementsByTagName("body")[0];

// Vista para cualquier ruta inexistente: sin menú lateral, navbar ni footer
export default {
  name: "NotFound",
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>

<style scoped>
.not-found {
  min-height: 100vh;
  background: #f8f9fa;
  display: grid;
  place-items: center;
  padding: 32px 16px;
}
.not-found-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(44, 58, 89, 0.06);
  padding: 40px 32px;
  max-width: 420px;
  width: 100%;
  text-align: center;
}
.not-found-logo {
  max-height: 56px;
  margin-bottom: 16px;
}
.not-found-code {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1;
  color: #f9b000;
}
.not-found-card h1 {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2c3a59;
  margin: 12px 0 6px;
}
.not-found-card p {
  color: #67748e;
  font-size: 0.95rem;
  margin-bottom: 24px;
}
</style>
